import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ServicesService {

  constructor(private http: HttpClient) { }


  getByProfessionalSpecialty(professionalId: string,specialtyId: string) {
    return this.http
    .get(`${environment.url}/professionals/${professionalId}/specialties/${specialtyId}/services`) as Observable<any[]>;
  }

  getBySpecialty(specialtyId: string) {
    return this.http
    .get(`${environment.url}/specialties/${specialtyId}/services`) as Observable<any[]>;
  }

  getAll(queryParamas: any = {}) {
    return this.http
      .get(`${environment.url}/services`, {
        params: queryParamas
      }).pipe(map((res: any) => res['hydra:member'])) as Observable<any[]>
  }
}
